import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { LazyLoadLegacyStore } from './lazy-load-legacy-store';
import { APPS_ENABLED, LOAD_LEGACY } from './lazy-load-legacy.constants';
import { LazyLoadLegacyDirective } from './lazy-load-legacy.directive';
import { LazyLoadConfig } from './lazy-load-legacy.model';
import { LazyLoadLegacyService } from './lazy-load-legacy.service';

import { LazyLoadService } from '@shared/services/lazy-load.service';

@NgModule({
    declarations: [ LazyLoadLegacyDirective],
    imports: [CommonModule],
    exports: [LazyLoadLegacyDirective],
    providers: [LazyLoadLegacyService, LazyLoadLegacyStore, LazyLoadService],
})
export class LegacyModule {
    /**
     * Use this method in your root module to provide the LegacyService
     */
    public static forRoot(_config: any = {}): ModuleWithProviders<LegacyModule> {
        return {
            ngModule: LegacyModule,
            providers: [LazyLoadLegacyStore],
        };
    }

    /**
     * Use this method in your other (non root) modules to import the directive
     */
    public static forChild(config: LazyLoadConfig = {}): ModuleWithProviders<LegacyModule> {
        return {
            ngModule: LegacyModule,
            providers: [
                { provide: APPS_ENABLED, multi: true, useValue: config.enable || [] },
                { provide: LOAD_LEGACY, multi: true, useValue: true },
                LazyLoadLegacyService,
            ],
        };
    }
}
